import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAttachmentAppEntityApplicationRead,
  AttachmentAppEntityApplicationRead,
  AttachmentAttachmentRead
} from '../../../../../../openapi';
import { AttachmentPositions } from '../../../../../../services/application.common.model';

@Injectable()
export class AttachmentsForm extends AppForm {
  constructor() {
    super({});
  }

  public buildForm(positions: AttachmentPositions, value?: ApplicationAppEntityApplicationRead | null): void {
    positions.forEach(p => {
      this.addControl(
        p.tag,
        new FormControl<AttachmentAttachmentRead[]>([], {
          validators: p.required ? [Validators.minLength(1), Validators.required] : [],
          nonNullable: true
        })
      );
    });
    this.patchFormValues(value);
  }

  public get values(): AttachmentAttachmentRead[] {
    let result: AttachmentAttachmentRead[] = [];
    Object.keys(this.controls).forEach(key => {
      result = result.concat(this.get(key)?.value);
    });
    return result;
  }

  public override patchFormValues(
    value?: ApplicationAppEntityApplicationRead | null
  ): void {
    if (value?.attachments?.length) {
      const attachments: Array<AttachmentAppEntityApplicationRead | undefined> =
        value?.attachments?.map((v: ApplicationAttachmentAppEntityApplicationRead) => v?.attachment) || [];
      const tags: string[] = attachments.map(v => v?.tag).filter(v => !!v) as string[];
      tags.forEach(tag => {
        this.get(tag)?.setValue(attachments.filter(v => v?.tag === tag));
      });
    }
  }
}
